import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
import store from "./index.js"
vue.use(vuex);

const avancenacional = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/avancenacional`,
    state: {
        avance: {},
        avances: []
    }
}).get({
    action: "get_avancenacional",
    path: function (obj) {
        return `/${obj.idavancenacional}`;
    },
    onSuccess: (state, payload) => {
        state.avance = payload.data;
    }
}).get({
    action: "get_avancenacionalbyplan",
    path: function (obj) {
        return `avancesporplan/${obj.idnacional}`;
    },
    onSuccess: (state, payload) => {
        state.avances = payload.data;
    }
}).put({
    action: "put_avancenacional",
    onSuccess: (state, payload) => {
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {                
        store.dispatch("mensaje/set_error", error);
    }     
}).getStore();

avancenacional.getters = {
    gavancenacional: state => {
        return state.avance
    },
    gavancenacionalbyplan: state => {
        return state.avances
    }

}
export default avancenacional;